import { Icon } from '@hotjar/hotsauce';
import FlagComponents from 'country-flag-icons/react/3x2';
import { hasFlag } from 'country-flag-icons';

interface CountryFlagProps {
  code: string | null;
  /**
   * Size of the icons. Only 3 sizes supported, to result in 16/32/48 px.
   */
  size?: 'm' | 'l' | 'xl';
  /**
   * Styles override.
   */
  className?: string;
}

const WIDTH = {
  m: 16,
  l: 32,
  xl: 48,
};

export function CountryFlag({ code = '', size = 'm', ...props }: CountryFlagProps): JSX.Element {
  if (code == null || !hasFlag(code.toUpperCase())) {
    return <Icon size={size} icon="unknown" color="text_light" {...props} />;
  }
  const upperCode = code.toUpperCase();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Flag = (FlagComponents as any)[upperCode];
  return <Flag width={WIDTH[size]} {...props} />;
}
